import ContactTile from "@gik/contact/components/ContactTile/ContactTile";
import { translationKeys } from "@gik/contact/i18n/en";
import { useBemCN } from "@gik/core/utils/bemBlock";
import React from "react";
import { useTranslation } from "react-i18next";

export default function KnowledgeBase() {
	const bem = useBemCN("knowledge-base");
	const { t } = useTranslation();

	return (
		<ContactTile
			{...bem()}
			title={t(translationKeys.KnowledgeBaseTitle)}
			buttonText={t(translationKeys.KnowledgeBaseButtonText)}
			buttonLink="https://help.giveinkind.com/en/"
		>
			{t(translationKeys.KnowledgeBaseContent)}
		</ContactTile>
	);
}
